import { Box, Stack, Typography } from "@mui/material";
import moment from "moment";
import { useMemo } from "react";

import Datetime from "@/common/components/Datetime/Datetime";
import { DateRangeDurationHumanizeOptions, DatetimeHelper } from "@/common/helpers/datetime";

import AppTooltip from "../Tooltip/AppTooltip";
import { IDatetimeRange } from "./DatetimeRange";

interface Props {
  range: IDatetimeRange;
  humanizeOptions?: DateRangeDurationHumanizeOptions;
  withTooltip?: boolean;
}

export default function DateRangeDuration({
  range,
  humanizeOptions = { isSuffix: false },
  withTooltip = true,
}: Props) {
  const durationM = useMemo(
    () =>
      range.startsAt && range.endsAt
        ? moment.duration(
            Math.abs(moment(range.startsAt).diff(moment(range.endsAt), "milliseconds")),
          )
        : undefined,
    [range.startsAt, range.endsAt],
  );

  const durationHumanized = useMemo(
    () =>
      durationM ? DatetimeHelper.humanizeMomentDuration(durationM, humanizeOptions) : undefined,
    [durationM],
  );

  if (!durationHumanized) {
    return <Box component='span'>-</Box>;
  }

  return (
    <AppTooltip
      sx={{ display: "inline" }}
      isEnabled={withTooltip}
      variant='helpText'
      title={
        <Typography component='div' variant='body2' sx={{ whiteSpace: "nowrap" }}>
          <Stack>
            <Box>Start: {range.startsAt ? <Datetime datetime={range.startsAt} /> : "-"}</Box>
            <Box>End: {range.endsAt ? <Datetime datetime={range.endsAt} /> : "-"}</Box>
            <Box>Duration: {durationHumanized || "-"}</Box>
          </Stack>
        </Typography>
      }
    >
      <Typography component='span'>{durationHumanized}</Typography>
    </AppTooltip>
  );
}
